import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { PrismCard, PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { Illustration } from 'frontend-utils/index';
import CalendarPlaceholder from 'lumen/assets/images/market-insight/empty-state/calendar-placeholder.svg?raw';
import MarketGraphPlaceholder from 'lumen/assets/images/market-insight/empty-state/market-graph-placeholder.svg?raw';
import GeneralPageMain from 'lumen/components/general/page/main';

import styles from './market-insight-unsupported-market.module.css';

interface MarketInsightUnsupportedMarketSignature {
  Args: {
    model: unknown;
  };
}

<template>
  <GeneralPageMain>
    <div class="main-sidebar-and-content-container flex flex-row">
      <div>
        <Illustration
          @html={{CalendarPlaceholder}}
          class={{styles.mock-image}}
        />
      </div>
      <PrismCard class={{concat styles.chart-wrapper " m-500 flex flex-1"}}>
        <:content>
          <Illustration
            @html={{MarketGraphPlaceholder}}
            class={{styles.mock-image}}
          />

          <div class={{styles.overlay}} />

          <div class={{styles.overlay-message}}>
            <PrismMessage
              @description={{t "market_insight.plans.no_data.description"}}
              @illustration="100x100_heatmap"
              @title={{t "market_insight.plans.no_data.title"}}
            />
          </div>
        </:content>

      </PrismCard>
    </div>

  </GeneralPageMain>
  {{outlet}}
</template> satisfies TOC<MarketInsightUnsupportedMarketSignature>;
